module.exports = __webpack_public_path__ + "img/bg-reservedseating2-blue.c76c826e.jpg";